import { TableHeadersType } from "../../tableHeadersType";

export const TRIAL_BALANCE_HEADERS: TableHeadersType[] = [
  {
    label: 'Ledger Name',
    value: 'ledger_name',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Opening Balance',
    value: 'opening_balance',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Debit',
    value: 'total_debit_amount',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Credit',
    value: 'total_credit_amount',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Closing Balance',
    value: 'closing_balance',
    checked: true,
    defaultChecked: true
  },
];